// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3Y8qx","emails":"CreateEditClinics_emails__ZaS5Z","emailTagLabel":"CreateEditClinics_emailTagLabel__2JzwR"};